<template>
  <div class="integration-con">
    <div style="width: 350px; max-width: 100%">
      <div class="d-flex justify-space-between align-center" style="width: 100%">
        <span class="title"> SKY API Authorized </span>
        <v-switch
          style="width: min-content"
          color="primary"
          class="custom-input checkbox"
          density="compact"
          :loading="loadingData || state.loadAuthorize"
          :model-value="data?.is_connected"
          @update:model-value="
            if (!loadingData) {
              if ($event) {
                authorize();
              } else {
                $emit('update:data', {
                  is_connected: false
                });
                removeAuthorization();
              }
            }
          "
        ></v-switch>
      </div>

      <div
        v-if="data?.is_connected"
        class="d-flex justify-space-between align-center mt-2"
        style="width: 100%"
      >
        <span class="title">
          SKY API Terms
          {{
            !data.schools.some((s) => s.academicterms.length + s.advisoryterms.length) ? "Not" : ""
          }}
          Imported
        </span>
        <v-btn
          color="transparent"
          icon
          size="small"
          v-if="data.schools.some((s) => s.academicterms.length + s.advisoryterms.length)"
          @click="syncTerms()"
          :loading="state.loadingTerms || loadingData"
        >
          <v-tooltip activator="parent" location="bottom">Resync data from SKY API</v-tooltip>
          <v-icon>mdi-reload</v-icon></v-btn
        >
        <v-btn
          v-else
          append-icon="mdi-sync"
          @click="syncTerms()"
          :loading="state.loadingTerms || loadingData"
          >Sync</v-btn
        >
      </div>
    </div>
    <template v-if="data?.is_connected">
      <v-divider></v-divider>

      <!-- <template> -->
      <div class="mt-2">
        <div class="title">Sync Entities</div>
        <div class="directoryTable mt-3">
          <table class="table" style="margin-top: 0 !important">
            <tbody>
              <tr v-for="row in state.types" :key="row.type">
                <td style="border-right: 1px solid #e5e4db; min-width: 100px">
                  <div class="d-flex justify-center">
                    <v-checkbox
                      class="custom-input"
                      density="compact"
                      :model-value="row.checked"
                      :disabled="row.loading"
                      @update:model-value="
                        {
                          row.checked = $event;
                          if ($event && row.loaded) row.loaded = false;
                          if ($event && row.type == 'c-enroll') {
                            state.excludeModal = true;
                          }
                        }
                      "
                      style="max-width: 28px"
                    ></v-checkbox>
                  </div>
                </td>
                <td
                  style="
                    border-right: 1px solid #e5e4db;
                    text-align: center;
                    width: calc(50% - 50px);
                    min-width: 200px;
                  "
                >
                  {{ row.title }}
                </td>
                <td style="width: calc(50% - 50px); min-width: 200px">
                  <div v-if="row.loading && row.checked && !row.loaded">
                    <div class="d-flex align-center justify-center">
                      <v-progress-circular
                        color="primary"
                        size="small"
                        indeterminate
                      ></v-progress-circular>
                    </div>
                  </div>
                  <div v-if="!row.loading && row.loaded">
                    <div class="d-flex align-center justify-center">
                      Loaded
                      <v-icon color="green" size="small" class="ml-2">mdi-check-circle</v-icon>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div>
        <div class="d-flex align-center gap-3">
          <div class="title mt-4">Class Enrollment</div>
          <v-switch
            color="primary"
            class="custom-input"
            density="compact"
            style="max-width: 100px; max-height: 20px"
            :model-value="state.classEnrollment.checked"
            :disabled="state.classEnrollment.loading"
            :loading="state.classEnrollment.loading"
            @update:model-value="
              {
                state.classEnrollment.checked = !state.classEnrollment.checked;
                // if ($event) state.excludeModal = true;
              }
            "
          ></v-switch>
        </div>
        <div v-if="state.classEnrollment.checked" class="d-flex gap-3 flex-wrap mt-3 align-center">
          <div class="d-flex gap-3 flex-wrap align-center">
            <v-select
              density="comfortable"
              class="custom-input"
              bg-color="white"
              color="primary"
              label="Building"
              style="max-width: 100%; width: 300px"
              :items="buildings"
              item-value="value"
              item-title="title"
              v-model="state.building"
              clearable
            ></v-select>
          </div>
          <div class="d-flex gap-3 flex-wrap align-center">
            <v-select
              density="comfortable"
              class="custom-input"
              bg-color="white"
              color="primary"
              label="Academic Term"
              style="max-width: 100%; width: 300px"
              :items="academicTerms"
              item-value="value"
              item-title="title"
              v-model="state.academicTerm"
              clearable
            ></v-select>
            <v-select
              density="comfortable"
              class="custom-input"
              bg-color="white"
              color="primary"
              label="Advisory Term"
              style="max-width: 100%; width: 300px"
              :items="advisoryTerms"
              item-value="value"
              item-title="title"
              v-model="state.advisoryTerm"
              clearable
            ></v-select>
          </div>
          <div class="d-flex gap-3 flex-wrap align-center">
            <template
              v-if="
                (state.academicTerm || state.advisoryTerm) &&
                state.building &&
                buildings.find((b) => b.value === state.building)
              "
            >
              <v-btn :disabled="state.classEnrollment.loading" @click="state.excludeModal = true"
                >Exclude Sections</v-btn
              >
            </template>

            <v-radio-group inline v-model="state.syncType" class="custom-input">
              <v-radio color="primary" label="Append" value="append"></v-radio>
              <v-radio color="primary" label="Overwrite" value="overwrite"></v-radio>
            </v-radio-group>
          </div>
        </div>
      </div>
      <!-- </template> -->
      <div class="mt-5 d-flex gap-5">
        <v-btn
          @click="sync"
          :disabled="disableSync"
          :loading="
            state.types.some((i) => i.loading) ||
            state.classEnrollment.loading ||
            state.loadingSections ||
            state.loadingSync
          "
          >Sync</v-btn
        >
      </div>
    </template>
    <div class="mt-5"></div>
  </div>
  <exclude-modal
    v-if="data"
    v-model:show="state.excludeModal"
    :data="data"
    :academic-term="state.academicTerm || undefined"
    :advisory-term="state.advisoryTerm || undefined"
    :building="state.building"
    :sections="sections"
    :loading="loadingSections"
    @reload="reloadSections"
  ></exclude-modal>
  <bb-sso-modal
    v-if="data"
    :data="data"
    :show="ssoModal"
    @update:show="$emit('update:ssoModal', $event)"
    @update:data="$emit('update:data', $event)"
  ></bb-sso-modal>
</template>

<script setup lang="ts">
import type { BlackBaudIntegration } from "@/api_types/school";
import FetchService from "@/services/fetch.service";
import { computed } from "vue";
import { reactive } from "vue";
import ExcludeModal from "./ExcludeModal.vue";
import { onMounted } from "vue";
import { watch } from "vue";
import BbSsoModal from "./bbSsoModal.vue";
import { useAlertsStore } from "@/stores/alerts";
import { integrationWindow } from "@/utils/integrationWindow";
import recursiveFetch from "@/utils/recursiveFetch";
import { asyncComputed } from "@/utils/asyncComputed";
import { useSchoolStore } from "@/stores/school";
const BASE_URL = import.meta.env.VITE_BASE_URL;

const props = defineProps<{
  data?: BlackBaudIntegration;
  loadingData: boolean;
  ssoModal: boolean;
}>();
const emit = defineEmits<{
  (event: "update:data", val: Partial<BlackBaudIntegration>): void;
  (event: "reload:data"): void;
  (event: "update:ssoModal", val: boolean): void;
}>();

const alertStore = useAlertsStore();
const schoolStore = useSchoolStore();

const state = reactive({
  types: [
    {
      type: "parents",
      title: "Parents",
      async sync() {
        if (!this.checked) return;
        this.loading = true;
        const res = await recursiveFetch(
          `*/blackbaud/parents?overwrite=${state.syncType === "overwrite"}`,
          "get"
        );
        if (res.success) {
          alertStore.addAlert("success", `Loaded ${res.count} parents successfully`);
          this.loaded = true;
          this.checked = false;
        } else {
          alertStore.addAlert("error", "Failed to load parents");
        }
        this.loading = false;
      },
      loading: false,
      checked: false,
      loaded: false
    },
    {
      type: "teachers",
      title: "Teachers",
      async sync() {
        if (!this.checked) return;
        this.loading = true;
        const res = await recursiveFetch(
          `*/blackbaud/teachers?overwrite=${state.syncType === "overwrite"}`,
          "get"
        );
        if (res.success) {
          alertStore.addAlert("success", `Loaded ${res.count} teachers successfully`);
          this.loaded = true;
          this.checked = false;
        } else {
          alertStore.addAlert("error", "Failed to load teachers");
        }
        this.loading = false;
      },
      loading: false,
      checked: false,
      loaded: false
    },
    {
      type: "students",
      title: "Students",
      async sync() {
        if (!this.checked) return;
        this.loading = true;
        const res = await recursiveFetch(
          `*/blackbaud/students?overwrite=${state.syncType === "overwrite"}`,
          "get"
        );
        if (res.success) {
          alertStore.addAlert("success", `Loaded ${res.count} students successfully`);
          this.loaded = true;
          this.checked = false;
        } else {
          alertStore.addAlert("error", "Failed to load students");
        }
        this.loading = false;
      },
      loading: false,
      checked: false,
      loaded: false
    }
  ],
  classEnrollment: {
    type: "c-enroll",
    title: "Class Enrollment",
    async sync() {
      if (!(this.checked && state.building && (state.advisoryTerm || state.academicTerm))) {
        this.loading = false;
        return;
      }
      this.loading = true;
      const act = state.academicTerm,
        adt = state.advisoryTerm,
        building = state.building;
      let terms = [act, adt].filter(Boolean).join(",");

      alertStore.addAlert("info", `Loading Class Enrollment, this might take a while`);
      const res = await recursiveFetch(
        `*/blackbaud/termenrollment/${building}/${terms}?overwrite=${
          state.syncType === "overwrite"
        }`,
        "get"
      );
      if (res.success) {
        alertStore.addAlert("success", `Loaded ${res.count} Class Enrollment successfully`);
        this.checked = false;
      } else {
        alertStore.addAlert("error", "Failed to load Class Enrollment");
      }
      this.loading = false;
      return res.success ? terms : undefined;
    },
    loading: false,
    checked: false
  },
  excludeModal: false,
  loadAuthorize: false,
  loadingTerms: false,
  building: null as any as 0,
  advisoryTerm: null as number | null,
  academicTerm: null as number | null,
  loadingSections: false,
  loadedSections: false,
  syncType: "append" as "append" | "overwrite",
  loadingSync: false
});

const syncTerms = async () => {
  state.loadingTerms = true;
  await FetchService.fetchData("*/blackbaud/terms", "get");
  await FetchService.fetchData("*/blackbaud/levels", "get");
  emit("reload:data");
  state.loadingTerms = false;
};

const buildings = computed(() => {
  if (!props.data) return [];
  return props.data.schools.map((s) => ({ title: s.name, value: s.school_level_id }));
});

const academicTerms = computed(() => {
  if (!props.data) return [];
  return (
    props.data.schools
      .find((s) => s.school_level_id === state.building)
      ?.academicterms.map((t) => ({
        title: `${t.description} (${t.school_year})`,
        value: t.term_id
      })) || []
  );
});
const advisoryTerms = computed(() => {
  if (!props.data) return [];
  return (
    props.data.schools
      .find((s) => s.school_level_id === state.building)
      ?.advisoryterms.map((t) => ({
        title: `${t.description} (${t.school_year})`,
        value: t.term_id
      })) || []
  );
});
type Sections = "academic_sections" | "advisory_sections";
const defVal = {
  academic_sections: [],
  advisory_sections: []
};
const {
  data: sections,
  loading: loadingSections,
  reload: reloadSections
} = asyncComputed(
  async (controller) => {
    if (!state.building || (!state.academicTerm && !state.advisoryTerm)) return defVal;
    let search = "?";
    if (state.academicTerm) search += `&academic_term_id=${state.academicTerm}`;
    if (state.advisoryTerm) search += `&advisory_term_id=${state.advisoryTerm}`;
    const res = await FetchService.fetchData(
      `/integration/blackbaud/sections${search}`,
      "get",
      undefined,
      undefined,
      controller
    );
    if (res?.academic_sections) {
      res?.academic_sections.map((i) => (i.excluded = !!i.excluded));
      res?.academic_sections.map((i) => (i.excluded = !!i.excluded));
      return res as Record<
        Sections,
        { section_id: number; section_name: string; excluded: boolean }[]
      >;
    }
    return defVal;
  },
  [() => state.academicTerm || "", () => state.advisoryTerm || ""],
  undefined,
  undefined,
  defVal
);

onMounted(() => {
  watch(
    () => state.building,
    () => {
      if (!academicTerms.value.find((i) => i.value === state.academicTerm))
        state.academicTerm = null;
      if (!advisoryTerms.value.find((i) => i.value === state.advisoryTerm))
        state.advisoryTerm = null;
    }
  );
});

const merge = async (terms?: string) => {
  const res = await FetchService.fetchData(
    `*/blackbaud/merge?overwrite=${state.syncType === "overwrite"}${
      terms ? "&terms=" + terms : ""
    }`,
    "get",
    undefined
  );
  
  if (res.success) {
    alertStore.addAlert("success", `Successfully merged entities`);
  } else alertStore.addAlert("error", `Failed to merged entities`);
};

const sync = async () => {
  state.loadingSync = true;
  try {
    await Promise.all(state.types.map((i) => i.sync()));
    let terms;
    if (state.classEnrollment.checked) {
      state.classEnrollment.loading = true;
      terms = await state.classEnrollment.sync();
    }
    await merge(terms);
  } catch (error) {
    //
  }
  state.loadingSync = false;
};

const syncSections = async () => {
  state.loadingSections = true;
  await FetchService.fetchData("*/blackbaud/sections?school_level=" + state.building, "get");
  state.loadedSections = true;
  reloadSections();
  state.loadingSections = false;
};

const authorize = async () => {
  const url = `${BASE_URL}/api/oauth2/blackbaud?school_id=${schoolStore.school_id}`;
  if (url) {
    state.loadAuthorize = true;

    const res = await integrationWindow(url, "Blackbaud integration enabled successfully");

    state.loadAuthorize = false;
    if (res.success) {
      emit("update:data", {
        is_connected: true
      });
    }
  }
};

const removeAuthorization = async () => {
  state.loadAuthorize = true;
  const res = await FetchService.fetchData("/integration/blackbaud", "put", {
    is_connected: false
  });
  if (typeof res === "object") {
    emit("update:data", res);
  }
  if (typeof res === "object" && !res.is_connected) {
    alertStore.addAlert("success", "Blackbaud integration disabled successfully");
  } else {
    alertStore.addAlert("error", "Failed to disabled Blackbaud integration");
    emit("update:data", {
      is_connected: true
    });
  }
  state.loadAuthorize = false;
};

watch(sections, async () => {
  if (
    !(sections.value.academic_sections.length + sections.value.advisory_sections.length) &&
    state.building &&
    (state.academicTerm || state.advisoryTerm) &&
    !loadingSections.value &&
    !state.loadedSections
  ) {
    await syncSections();
  }
});

watch([() => state.building, () => state.academicTerm, () => state.advisoryTerm], () => {
  state.loadedSections = false;
});

const disableSync = computed(() => {
  if (
    state.classEnrollment.checked &&
    !sections.value.academic_sections.length &&
    !sections.value.advisory_sections.length &&
    (!state.loadedSections || (!state.academicTerm && !state.advisoryTerm))
  )
    return true;
  return false;
});
</script>

<style scoped lang="scss">
@use "@/assets/_vars.scss" as *;
@use "@/assets/_breakpoints.scss" as breakpoints;

.title {
  color: $primary;
  font-weight: 600;
  font-size: 1.25rem;
}
.integration-con {
  margin-top: 30px;
}

.checkbox {
  :deep(.v-input__control) {
    .v-selection-control {
      justify-content: flex-end;
    }
  }
}
</style>
